import 'polyfills';
import { Providers } from 'providers';
import React from 'react';
import ReactDOM from 'react-dom/client';

import App from 'components/App';

import initializeSentry from 'lib/errors/initializeSentry';
import { onUnhandledError } from 'lib/errors/onError';

// Import these styles separately from GlobalStyle to prevent flickering with dev server
// eslint-disable-next-line import/extensions
import 'static/styles/fonts.css';

import * as serviceWorker from './serviceWorker';

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

// Catch unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  // The promise was already rejected here, so we should look at the reason property. It could
  // be an error object or a string or an object, etc, etc. So let's be safe and handle it carefully.
  let error;
  if (event.reason instanceof Error) {
    error = event.reason;
  } else if (typeof event.reason === 'object' && event.reason !== null) {
    // Try to get meaningful object representation
    try {
      const serialized = JSON.stringify(event.reason);
      error = new Error(`Unhandled rejection with object: ${serialized}`);
    } catch (e) {
      // Handle JSON serialization errors
      error = new Error(
        `Unhandled rejection with non-serializable object: ${Object.keys(event.reason).join(', ')}`,
      );
    }
  } else {
    // Handle primitives or undefined
    error = new Error(String(event.reason));
  }

  onUnhandledError(error);
  event.preventDefault();
});

initializeSentry();

const render = (Component: React.ElementType) => {
  ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    // @ts-ignore some issue with children prop
    <Providers>
      <Component />
    </Providers>,
  );
};

render(App);

if (module.hot) {
  module.hot.accept('./components/App', () => {
    // eslint-disable-next-line
    const NextApp = require('./components/App').default;
    render(NextApp);
  });
}
